import { Link } from 'react-router-dom';
import { useDocumentTitle } from '../lib/useDocumentTitle';

export function NotFoundPage() {
  useDocumentTitle('Page not found | Flying Muse');
  return (
    <section className="flex min-h-[70vh] items-center justify-center bg-cream">
      <div className="container-content section-pad py-24 text-center">
        <p className="eyebrow eyebrow--center">404</p>
        <h1 className="mt-4 font-display text-[clamp(2.25rem,5vw,3.5rem)] font-medium text-charcoal">
          This page took flight
        </h1>
        <p className="mx-auto mt-4 max-w-md font-sans text-base font-light leading-relaxed text-stone">
          The page you&rsquo;re looking for isn&rsquo;t here. Let&rsquo;s get you back to the
          caldera.
        </p>
        <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
          <Link to="/" className="btn btn-primary">
            Back Home
          </Link>
          <Link to="/experiences" className="btn btn-outline-dark">
            View Experiences
          </Link>
        </div>
      </div>
    </section>
  );
}
